'use client';
import Image from 'next/image';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import Icon1 from '@images/icon1.svg';
import Icon2 from '@images/icon2.svg';
import Icon3 from '@images/icon3.svg';
import ExpertWidget from '@components/ExpertWidget';

export default function PremiumCoursePage() {
  const testimonySliderSettings = {
    infinite: false,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    centerPadding: '20px',
    variableWidth: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: '0px',
          centerMode: false,
          variableWidth: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <main className="page-premium-course">
      <section className="section-banner">
        <div className="container">
          <div className="banner-premium-course">
            <h1 className="banner-title">Art of Living Premium Course</h1>
            <div className="banner-text">
              Find new levels of calm and energy for life
            </div>
            <Image
              src="/images/premium-banner-flower.webp"
              alt="gurudev"
              className="banner-image"
              width={351}
              height={297}
            />
            <div className="banner-button">
              <a
                href={`${process.env.NEXT_PUBLIC_AUTH_APP_URL}/us-en/course/scheduling?courseType=art-of-living-premium-program`}
                className="button"
              >
                Enroll Now
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="premium-key-points">
        <div className="container">
          <div className="key-points-listing">
            <div className="key-points-item">
              <div className="key-points-item-image">
                <Image
                  src="/images/aolp-size.png"
                  alt="gurudev"
                  className="key-points-image"
                  width={50}
                  height={50}
                />
              </div>
              <div className="key-points-item-content">
                Reduce stress, anxiety, and depression
              </div>
            </div>
            <div className="key-points-item">
              <div className="key-points-item-image">
                <Image
                  src="/images/aolp-increase.png"
                  alt="gurudev"
                  className="highlight-image"
                  width={50}
                  height={50}
                />
              </div>
              <div className="key-points-item-content">
                Increase your energy levels
              </div>
            </div>
            <div className="key-points-item">
              <div className="key-points-item-image">
                <Image
                  src="/images/aolp-wellness.png"
                  alt="gurudev"
                  className="key-points-image"
                  width={50}
                  height={50}
                />
              </div>
              <div className="key-points-item-content">
                Learn wellness practices that last a lifetime
              </div>
            </div>
          </div>
          <div className="discover-box">
            <div className="section-title">
              Discover Art of Living's Premium Course
            </div>
            <div className="section-content">
              <Image
                src="/images/sky-sahaj.png"
                alt="sky sahaj"
                className="sky-sahaj-image"
                width={343}
                height={100}
              />
              <p>
                This course combines two powerful experiences into one. You will
                learn Sudarshan Kriya™ (SKY Breath Meditation), as taught in the
                Art of Living Part 1 course, and also acquire a personal mantra,
                a charged sound that makes meditation easier, introduced in the
                Sahaj Samadhi Meditation course.
              </p>
              <p>
                SKY Breath Meditation is an evidence-based breathwork practice
                known to reduce stress and anxiety, with noticeable results in
                just one week. This practice helps you let go of the past and
                access a heightened state of awareness and relaxation, providing
                you with a repeatable tool. Sahaj Samadhi Meditation takes this
                further by deepening your experiences of rest and awareness,
                freeing your mind from day-to-day worries.
              </p>
              <p>
                The combination has a compounding effect that accelerates your
                journey towards tranquility. In the end, you walk away with a
                comprehensive toolkit of breathwork and meditation that mutually
                enhance each other.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section-course-highlights">
        <div className="container">
          <div className="section-title">
            <strong>COURSE</strong> HIGHLIGHTS
          </div>
          <div className="course-highlights-listing">
            <div className="course-highlights-item">
              <div className="course-highlights-item-image">
                <Image
                  src="/images/aolp-ch-1.jpg"
                  alt="gurudev"
                  className="highlight-image"
                  width={570}
                  height={450}
                />
              </div>
              <div className="course-highlights-item-content">
                <div className="course-highlights-item-title">
                  <strong>Pranayama</strong>
                </div>
                <div className="course-highlights-item-text">
                  Improve your energy levels and reduce stress through breathing
                  exercises
                </div>
              </div>
            </div>
            <div className="course-highlights-item">
              <div className="course-highlights-item-image">
                <Image
                  src="/images/aolp-ch-2.jpg"
                  alt="gurudev"
                  className="highlight-image"
                  width={570}
                  height={450}
                />
              </div>
              <div className="course-highlights-item-content">
                <div className="course-highlights-item-title">
                  <strong>Sudarshan Kriya™</strong> (SKY Breath Meditation)
                </div>
                <div className="course-highlights-item-text">
                  Learn the most powerful breathing technique of our time
                </div>
              </div>
            </div>
            <div className="course-highlights-item">
              <div className="course-highlights-item-image">
                <Image
                  src="/images/aolp-ch-3.jpg"
                  alt="gurudev"
                  className="highlight-image"
                  width={570}
                  height={450}
                />
              </div>
              <div className="course-highlights-item-content">
                <div className="course-highlights-item-title">
                  <strong>5 Keys</strong> to Joyful Life
                </div>
                <div className="course-highlights-item-text">
                  Simple toolkit to help you navigate life joyfully
                </div>
              </div>
            </div>
            <div className="course-highlights-item">
              <div className="course-highlights-item-image">
                <Image
                  src="/images/aolp-ch-4.jpg"
                  alt="gurudev"
                  className="highlight-image"
                  width={570}
                  height={450}
                />
              </div>
              <div className="course-highlights-item-content">
                <div className="course-highlights-item-title">
                  <strong>Community</strong>
                </div>
                <div className="course-highlights-item-text">
                  Connect with a community of like-minded people and a certified
                  instructor
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-impacts">
        <div className="container">
          <div className="section-title">
            <strong>IMPACTS</strong> OF SUDARSHAN KRIYA™
          </div>
          <div className="section-description">
            Science-backed benefits of Sudarshan Kriya, shown in over 100
            independent studies
          </div>
          <div className="impacts-listing">
            <div className="impacts-item">
              <div className="impacts-item-image">
                <Image
                  src={Icon1}
                  alt="gurudev"
                  className="impact-image"
                  width={36}
                  height={55}
                />
              </div>
              <div className="impacts-item-content">
                <div className="impacts-item-title">+33% Immune Cell Count</div>
                <div className="impacts-item-text">
                  Increase in lymphocytes in 6 weeks & remained in the normal
                  range
                </div>
              </div>
            </div>
            <div className="impacts-item">
              <div className="impacts-item-image">
                <Image
                  src={Icon2}
                  alt="gurudev"
                  className="impact-image"
                  width={36}
                  height={55}
                />
              </div>
              <div className="impacts-item-content">
                <div className="impacts-item-title">21% Life Satisfaction</div>
                <div className="impacts-item-text">Increase within 1 week</div>
              </div>
            </div>
            <div className="impacts-item">
              <div className="impacts-item-image">
                <Image
                  src={Icon3}
                  alt="gurudev"
                  className="impact-image"
                  width={36}
                  height={55}
                />
              </div>
              <div className="impacts-item-content">
                <div className="impacts-item-title">-57% Stress Hormones</div>
                <div className="impacts-item-text">
                  Decrease in serum cortisol in 2 weeks
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-courses-nearme">
        <div className="container">
          <iframe
            src={`${process.env.NEXT_PUBLIC_AUTH_APP_URL}/widget/nearby-courses/art-of-living-premium-program`}
            name="carouselIframe"
            height="900px"
            width="100%"
          ></iframe>
        </div>
      </section>
      <section className="section-testimonial">
        <div className="container">
          <div className="section-title">Transforming lives</div>
          <Slider {...testimonySliderSettings}>
            <div className="slide-wrap">
              <div className="slide-title">
                <i>“The experience was warm, kind, and powerful.”</i>
              </div>
              <div className="slide-text">
                It truly felt like I was coming home. As I sat with myself and
                tuned in I could feel the empowerment and safety that lies
                within. Being able to reconnect with that is life changing.
              </div>
              <div className="slide-author-info">
                <div className="author-image">
                  <Image
                    src="/images/peter.original.png"
                    alt="gurudev"
                    className="shadow-medium"
                    width={55}
                    height={55}
                  />
                </div>
                <div className="author-content">
                  <div className="author-name">Peter D., Los Angeles</div>
                  <div className="author-position">
                    Art of Living Premium Participant
                  </div>
                </div>
              </div>
            </div>
            <div className="slide-wrap">
              <div className="slide-title">
                <i>“This was just what I was looking for.”</i>
              </div>
              <div className="slide-text">
                It gave me a routine that allows me to feel empowered and
                peaceful. So much gratitude.
              </div>
              <div className="slide-author-info">
                <div className="author-image">
                  <Image
                    src="/images/aryanne.original.png"
                    alt="gurudev"
                    className="shadow-medium"
                    width={55}
                    height={55}
                  />
                </div>
                <div className="author-content">
                  <div className="author-name">Aryanne D., Los Angeles</div>
                  <div className="author-position">
                    Art of Living Premium Participant
                  </div>
                </div>
              </div>
            </div>
            <div className="slide-wrap">
              <div className="slide-title">
                <i>
                  “The art or living retreat was truly life-changing for me,”
                </i>
              </div>
              <div className="slide-text">
                and I wholeheartedly recommend it to everyone. It was brimming
                with love and played a significant role in helping me find
                greater inner peace and balance.
              </div>
              <div className="slide-author-info">
                <div className="author-image">
                  <Image
                    src="/images/amanda.original.png"
                    alt="gurudev"
                    className="shadow-medium"
                    width={55}
                    height={55}
                  />
                </div>
                <div className="author-content">
                  <div className="author-name">
                    Amanda Oleander, Artist, Los Angeles
                  </div>
                  <div className="author-position">
                    Art of Living Premium Participant
                  </div>
                </div>
              </div>
            </div>
            <div className="slide-wrap">
              <div className="slide-title">
                <i>“...very, very powerful... such a sense of calm”</i>
              </div>
              <div className="slide-text">
                It was very, very powerful. I gained such a sense of calm, more
                than I ever could have imagined.
              </div>
              <div className="slide-author-info">
                <div className="author-image">
                  <Image
                    src="/images/1-silent-comments.png"
                    alt="gurudev"
                    className="shadow-medium"
                    width={55}
                    height={55}
                  />
                </div>
                <div className="author-content">
                  <div className="author-name">Max Goldberg</div>
                  <div className="author-position">
                    Art of Living Premium Participant
                  </div>
                </div>
              </div>
            </div>
            <div className="slide-wrap">
              <div className="slide-title">
                <i>“relaxed, refreshed, and happier”</i>
              </div>
              <div className="slide-text">
                It helped me to put into practice the valuable wisdom which I
                had picked up on the Art of Living Part 1 Course. I came away
                relaxed, refreshed and happier than I had felt for a long time.
              </div>
              <div className="slide-author-info">
                <div className="author-image">
                  <Image
                    src="/images/2-silent-comments.png"
                    alt="gurudev"
                    className="shadow-medium"
                    width={55}
                    height={55}
                  />
                </div>
                <div className="author-content">
                  <div className="author-name">Julie Madeley</div>
                  <div className="author-position">
                    Art of Living Premium Participant
                  </div>
                </div>
              </div>
            </div>
            <div className="slide-wrap">
              <div className="slide-title">
                <i>“felt more balanced”</i>
              </div>
              <div className="slide-text">
                I've been on quite a few silent retreats in the past and this
                felt more balanced, nourishing and comfortable than any other
                retreat I'd been on.
              </div>
              <div className="slide-author-info">
                <div className="author-image">
                  <Image
                    src="/images/3-silent-comments.png"
                    alt="gurudev"
                    className="shadow-medium"
                    width={55}
                    height={55}
                  />
                </div>
                <div className="author-content">
                  <div className="author-name">Michelle Garisson</div>
                  <div className="author-position">
                    Art of Living Premium Participant
                  </div>
                </div>
              </div>
            </div>
            <div className="slide-wrap">
              <div className="slide-title">
                <i>Calmness and peace</i>
              </div>
              <div className="slide-text">
                I am enjoying the calmness and peace that comes with Sahaj
                Samadhi meditation.
              </div>
              <div className="slide-author-info">
                <div className="author-image">
                  <Image
                    src="/images/1-sahaj-comment.png"
                    alt="gurudev"
                    className="shadow-medium"
                    width={55}
                    height={55}
                  />
                </div>
                <div className="author-content">
                  <div className="author-name">Dr. Lewis</div>
                  <div className="author-position">
                    Art of Living Premium Participant
                  </div>
                </div>
              </div>
            </div>
            <div className="slide-wrap">
              <div className="slide-title">
                <i>Reservoir of energy</i>
              </div>
              <div className="slide-text">
                Sahaj Samadhi allows me to tap into a reservoir of energy, which
                leaves me rejuvenated and revitalized, like a new person.
              </div>
              <div className="slide-author-info">
                <div className="author-image">
                  <Image
                    src="/images/brian-review.png"
                    alt="gurudev"
                    className="shadow-medium"
                    width={55}
                    height={55}
                  />
                </div>
                <div className="author-content">
                  <div className="author-name">Brian</div>
                  <div className="author-position">
                    Art of Living Premium Participant
                  </div>
                </div>
              </div>
            </div>
            <div className="slide-wrap">
              <div className="slide-title">
                <i>Happy</i>
              </div>
              <div className="slide-text">
                I got so happy for no reason. I hadn’t experienced that in a
                long time.
              </div>
              <div className="slide-author-info">
                <div className="author-image">
                  <Image
                    src="/images/phillip-review.png"
                    alt="gurudev"
                    className="shadow-medium"
                    width={55}
                    height={55}
                  />
                </div>
                <div className="author-content">
                  <div className="author-name">Phillip</div>
                  <div className="author-position">
                    Art of Living Premium Participant
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </section>
      <section className="section-price">
        <div className="container">
          <div className="price-box">
            <div className="price-box-title">
              Unlock new levels of calm and energy for life with this 3-day
              online or in-person course starting at $495
            </div>
            <div className="price-box-features">
              <div className="feature-item">* SKY Breath Meditation</div>
              <div className="feature-item">* Pranayama</div>
              <div className="feature-item">* Personal Mantra</div>
              <div className="feature-item">* 5 Keys to Joyful Life</div>
              <div className="feature-item">
                * 10.5 hrs Duration of the course
              </div>
            </div>
            <div className="price-box-total-action">
              <div className="price-box-total">
                Total value - <s>$590</s> $495
              </div>
              <div className="price-box-action">
                <a
                  className="premium-button-enroll"
                  href={`${process.env.NEXT_PUBLIC_AUTH_APP_URL}/us-en/course/scheduling?courseType=art-of-living-premium-program`}
                  target="_self"
                >
                  Enroll Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-faq">
        <div className="container">
          <div className="section-title">FAQs</div>
          <div className="faq-listing">
            <div className="faq-item">
              <div className="faq-question">
                What are the benefits of Sudarshan Kriya™?
              </div>
              <div className="faq-answer">
                Sudarshan Kriya™ taught in the Art of Living Part 1 course has
                been researched in over 100 independent studies and shown
                significant mind and body benefits. It lowers stress levels,
                improves mental clarity, enhances emotional well-being,
                contributes to better sleep, raises energy levels, and provides
                a greater sense of inner peace. The physical benefits include
                boosting immunity, heart health, and more.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                How is Sahaj Samadhi Meditation different from guided
                meditation?
              </div>
              <div className="faq-answer">
                Guided meditations help you meditate with verbal instructions
                and music. They help you relax and unwind by providing a
                soothing and peaceful ambience. On the other hand, Sahaj Samadhi
                Meditation is a mantra-based meditation technique. The mantra is
                a charged, subtle sound that takes you to deeper states of
                consciousness. Guided meditations require, well, guidance, but
                once you learn Sahaj Samadhi Meditation, you can meditate on
                your own with this technique. It needs 20 minutes of your time,
                and a quiet corner where you can sit comfortably. With regular
                practice, you will feel more at peace and start noticing the
                improvements in your physical health, mental acumen, increased
                awareness, and sharpened intuitive skills.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                What’s the duration of the Art of Living Premium course?
              </div>
              <div className="faq-answer">
                The duration of the Art of Living Premium course is 3 days with
                3.5 hours of live online or in-person sessions each day with a
                certified instructor.
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="footer-sticky-bar">
        <div className="container">
          <div className="bar-title">
            Register for the Art of Living Premium Course
          </div>
          <a
            href={`${process.env.NEXT_PUBLIC_AUTH_APP_URL}/us-en/course/scheduling?courseType=art-of-living-premium-program`}
            className="bar-button"
          >
            Enroll Now
          </a>
        </div>
      </section>
      <ExpertWidget pageTitle="Premium Course"></ExpertWidget>
    </main>
  );
}
